import { render, staticRenderFns } from "./GalleryBrochure.vue?vue&type=template&id=78d19297&"
import script from "./GalleryBrochure.vue?vue&type=script&lang=js&"
export * from "./GalleryBrochure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports